/**
 * Baja al final SOLO la cajita con scroll propio que contiene al elemento (su
 * ancestro con overflow-y auto/scroll), sin tocar la ventana. Reemplaza a
 * `endRef.scrollIntoView()`, que arrastraba TODA la página hacia el chat/email
 * cuando estos módulos viven a mitad de una pestaña del claim (bug: la página del
 * claim abría en el medio en vez de arriba).
 */
export function scrollBoxToEnd(el: HTMLElement | null): void {
  if (!el) return;
  let box: HTMLElement | null = el.parentElement;
  while (box) {
    const oy = getComputedStyle(box).overflowY;
    if ((oy === 'auto' || oy === 'scroll') && box.scrollHeight > box.clientHeight) {
      box.scrollTop = box.scrollHeight;
      return;
    }
    box = box.parentElement;
  }
  // Si no hay caja con scroll propio, NO se hace nada (no se mueve la ventana).
}
